import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../../apiClient';
import DashboardLayout from './DashboardLayout ';

const HrContanct = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        agreeTerms: false,
    });
    const [isMessageSent, setIsMessageSent] = useState(false);

    useEffect(() => {
        // Check if the user is logged in
        const loggedInUser = JSON.parse(localStorage.getItem('user')); // Assuming user data is stored in localStorage
        if (loggedInUser) {
            setFormData((prevData) => ({
                ...prevData,
                name: loggedInUser.userName || '',
                email: loggedInUser.userEmail || '',
            }));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        setFormData((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.agreeTerms) {
            alert('Please accept the terms and conditions.');
            return;
        }

        try {
            const response = await api.sendMessage(formData); // Use the API client
            if (response.status === 200) {
                setIsMessageSent(true);

            }
        } catch (error) {
        }
    };

    const homePageUrl =
        window.location.hostname === 'localhost'
            ? 'http://localhost:3001'
            : 'https://jobbox.one';
    return (
        <DashboardLayout>
            <div>
                <Container className="main-content">
                    <Row>
                        <Col md={6}>
                            <h2>Contact Us</h2>
                            <p>
                                We are here to assist you with any inquiries or questions you may have.
                                Feel free to reach out to us via email at ping@jobbox.one .
                                Our office is located at Bangalore (India) | Cupertino (USA) | Davis (USA). We look forward to hearing from you!
                            </p>
                            <div className="contact-info">
                                <p><FontAwesomeIcon icon={faEnvelope} /> Email:
                                    <a href="mailto:ping@jobbox.one" style={{ textDecoration: 'none', color: 'blue' }}>
                                        ping@jobbox.one
                                    </a>
                                </p>
                                <p>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} /> Address:
                                    <a
                                        href="https://www.google.com/maps?q=Bangalore,India"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'blue', marginRight: '5px' }}
                                    >
                                        Bangalore (India)
                                    </a>
                                    |
                                    <a
                                        href="https://www.google.com/maps?q=Cupertino,USA"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'blue', marginLeft: '5px', marginRight: '5px' }}
                                    >
                                        Cupertino (USA)
                                    </a>
                                    |
                                    <a
                                        href="https://www.google.com/maps?q=Davis,USA"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'blue', marginLeft: '5px' }}
                                    >
                                        Davis (USA)
                                    </a>
                                </p>

                            </div>
                        </Col>
                        <Col md={6}>
                            <h2>Send Us a Message</h2>

                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="name">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        disabled // Disable input for logged-in user
                                    />
                                </Form.Group>
                                <Form.Group controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        disabled // Disable input for logged-in user
                                    />
                                </Form.Group>
                                <Form.Group controlId="phone">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <Form.Control
                                        type="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="subject">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="message">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="agreeTerms">
                                    <Form.Check
                                        type="checkbox"
                                        name="agreeTerms"
                                        checked={formData.agreeTerms}
                                        onChange={handleChange}
                                        label={<span>I agree to the <Link to="/termsandconditions">Terms and Conditions</Link></span>}
                                        required
                                    />
                                </Form.Group>
                                {!isMessageSent ? (
                                    <Button variant="primary" type="submit">
                                        Send Message
                                    </Button>
                                ) : (
                                    <Alert variant="success" className="text-center">
                                        Your message has been sent successfully!{' '}
                                        <a href={homePageUrl}>Go to Home Page</a>
                                    </Alert>
                                )}
                            </Form>

                        </Col>
                    </Row>
                </Container>
            </div>
        </DashboardLayout>
    )
}

export default HrContanct
